// import $ from 'jquery' // jQuery

import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉
import setCookie from './functions/_cookie-setCookie.js' // Cookie発行

/* global  */ // tUrl等のグローバル変数を宣言する

// import './_top.js'
// import './_form.js'
// import './_modal'

import {
  Autoplay,
  Controller,
  EffectFade,
  Navigation,
  Pagination,
  EffectCoverflow,
  Thumbs,
  Scrollbar,
  Swiper,
} from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, EffectCoverflow, Thumbs, Scrollbar]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

let LPSlider_01 = new Swiper('.PC_slider, .SP_slider', {
  speed: 1000,
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
  },
  slidesPerView: 1,
  spaceBetween: 0,
})

let LPSlider_02 = new Swiper('.process__slider', {
  slidesPerView: 1,
  speed: 800,
  spaceBetween: 60,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar', //スクロールバーの要素のセレクタ
    hide: false,
    draggable: true, //スクロールバーをドラッグ可能にする
  },
  breakpoints: {
    768: {
      spaceBetween: 60,
      slidesPerView: 3.5,
    },
  },
})

//  ###    ###   #####   ####      ###    ##
//  ## #  # ##  ##   ##  ##  ##   ## ##   ##
//  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
//  ##      ##  ##   ##  ##  ##  #######  ##
//  ##      ##   #####   ####    ##   ##  ######
const modals = document.getElementsByClassName('js-modal') // モーダル本体
if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    e.preventDefault()
    modalClose()
    const target = e.target.closest('.js-modal-open').dataset.modal

    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }

    // scrollLock('body', '#modalOverlay')
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    modalClose()
    // scrollLock('body', '#modalOverlay')
  })
}

function modalClose() {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
}

const elmSwiper = document.querySelectorAll('.productModal-slider')
const elmThumb = document.querySelectorAll('.productModal-thumbs')
if (elmSwiper.length > 0) {
  for (let i = 0; i < elmSwiper.length; i++) {
    elmSwiper[i].className += i
    elmThumb[i].className += i
    const sliderThumbnail = new Swiper('.productModal-thumbs' + i, {
      slidesPerView: 4,
      spaceBetween: 4,
    })

    const swiper = new Swiper('.productModal-slider' + i, {
      loop: true,
      thumbs: {
        swiper: sliderThumbnail,
      },
    })
  }
}

function getCookie(cookieName) {
  let cookie = {}
  document.cookie.split(';').forEach(function (el) {
    let [key, value] = el.split('=')
    cookie[key.trim()] = value
  })
  return cookie[cookieName]
}

const btnClose = document.querySelector('.modal__close')
const modalWrap = document.querySelector('.modal')

modalWrap.style.display = 'none'
const isAdult = getCookie('adult')
if (isAdult === 'yes' || typeof isAdult !== 'undefined') {
  // modalWrap.classList.add('fade')
  modalWrap.classList.add('fadeIn')
  modalWrap.style.display = 'block'
} else {
  modalWrap.classList.add('fadeIn')
  modalWrap.style.display = 'block'
}
console.log(isAdult)

btnClose.addEventListener('click', (e) => {
  setCookie('adult', 'yes', 60 * 60 * 24)
  modalWrap.classList.remove('fadeIn')
  modalWrap.classList.add('fade')
})

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
// 画面に入った監視対象に.activeを付加
// Intersection Observer
window.intObs = function (rootMargin) {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('active')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}

if (!document.getElementById('page-top')) {
  window.intObs('-10% 0px')
}
